import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * SsoCallback — landing page after `/api/wemm/sso` redirects here with a
 * signed session token. We store the token, fetch the user via /me,
 * hydrate the auth context, and push to the dashboard.
 */
export default function SsoCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      navigate('/login?error=missing_sso_token', { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAuth(token, res.data);
        navigate('/dashboard', { replace: true });
      } catch (_e) {
        navigate('/login?error=sso_failed', { replace: true });
      }
    })();
  }, [params, navigate, setAuth]);

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center">
      <div className="text-center text-gray-300" data-testid="sso-callback-loading">
        <Loader2 className="w-10 h-10 animate-spin text-brand-gold mx-auto mb-4" />
        <p className="text-lg font-semibold text-white">Signing you in…</p>
        <p className="text-sm text-gray-400 mt-1">Welcome from WeMillionairesMM.</p>
      </div>
    </div>
  );
}
